<template>
  <div class="users">
    <Breadcrumb :home="home" :model="items" />

    <div class="user_list">
      <form class="form" @submit.prevent="saveUser()">
        <div class="name item">
             <InputText
            class="box p-m-1"
            type="text"
                    style=" width: 50px"
            v-model="form.rank"
            placeholder="Rank"
          />

          <InputText
            class="box p-m-1"
            type="text"
                    style=" width: 70px"
            v-model="form.persno"
            placeholder="GCSS-Army Pers. #"
          />

          <br/>
                    <InputText
            class="box p-m-1"
            type="text"
            v-model="form.lastname"
            placeholder="Lastname"
          />
          <InputText
            class="box p-m-1"
            type="text"
            v-model="form.firstname"
            placeholder="First name"
          />

        </div>
        <div class="email item">
          <InputText
            class="box p-m-1"
            type="text"
            v-model="form.email"
            placeholder="Email"
          />
        </div>

        <div class="UIC item">

<br/>
            <Dropdown
      v-model="form.uic"
      :options="uics"
      optionLabel="id"
      placeholder="Change User UIC"
      :filter="true"
      filterPlaceholder="Find Your UIC"
    />

        </div>


        <Dropdown
          class="p-mt-2 approval item"
          v-model="form.approved"
          :options="options"
          optionLabel="name"
          optionValue="code"
        />
        <br/>
        <Dropdown
          class="p-mt-2 role item"
          v-model="form.role"
          :options="roles"
          placeholder= "Assign Role"
        />        
        <div class="selector">
          <div @click="confirmRemove()" class="delete p-shadow-8">Delete</div>
        </div>

        <Dialog
          header="Confirmation"
          :visible="confirmRemoveDialog"
          :style="{ width: '350px' }"
          :modal="true"
        >
          <div class="confirmation-content">
            <i
              class="pi pi-exclamation-triangle p-mr-3"
              style="font-size: 2rem"
            />
            <span>Are you sure you want to delete this user?</span>
          </div>
          <template #footer>
            <Button
              label="No"
              icon="pi pi-times"
              @click="confirmRemoveDialog = false"
              class="p-button-text"
            />
            <Button
              label="Yes"
              icon="pi pi-check"
              @click="deleteUser()"
              class="p-button-text"
              autofocus
            />
          </template>
        </Dialog>
        <div>
          <Button
            class="create_button p-m-3 p-shadow-8"
            label="Save Changes"
            type="submit"
          />
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { fb_db, fs, fb_users } from "../firebase";
import Breadcrumb from "primevue/breadcrumb";
import Dropdown from "primevue/dropdown";
import Dialog from "primevue/dialog";
// import uics from '@/assets/uic.js';

export default {
  name: "UserEdit",
  components: {
    Dropdown,
    Breadcrumb,
    Dialog,
  },
  data() {
    return {
      home: { label: "Users List", to: "/users" },
      items: [{ label: "Edit"}],
      users: {},
      confirmRemoveDialog: false,
      removethisuser: null,

      form: {
        rank:null,
        firstname: null,
        lastname: null,
        dod: null,
        email: null,
        uic: null,
        puic: null,
        approved: null,
        role: null,
      },
      options: [
        {
          name: "Approved",
          code: true,
        },
        {
          name: "Not Approved",
          code: false,
        },
      ],
      uics: [],
      roles: ["Operator", "Mechanic", "Maint. Manager", "Clerk", "Org. Leader"],

    };

  },
  async mounted() {
    await this.getUser();
    await this.getUICs();
  },
  methods: {
 async getUser() {
      this.loading = true;
      await fb_db
        .collection("users")
        .doc(this.$route.params.id).get()
        .then((doc) => {
          let user = doc.data()
          this.form = user
          this.form.uic = {
            id: user.uic,
            puic: user.puic
          }
          this.form.id = doc.id;
          this.loading = false;
        })
        .catch((error) => {
          console.error("error getting users: ", error);
        });
    },
        async getUICs() {
      let uicData = await fb_db.collection("uics").get()
      uicData.forEach((doc) => {
        let item = doc.data();
        item.id = doc.id;
        this.uics.push(item);
      });
    },
    saveUser() {
      fb_db
        .collection("users")
        .doc(this.userId)
        .update({
          firstname: this.form.firstname,
          lastname: this.form.lastname,
          uic: this.form.uic.id, 
          puic: this.form.uic.puic,
          persno: this.form.persno,
          role: this.form.role,
          approved: this.form.approved})
        .then(() => {
          console.log("user successfully updated");

          this.$router.push("/users");
        })
        .catch((error) => {
          this.$toast.add({
            severity: "error",
            summary: "Error!",
            detail: error,
            life: 3000,
          });
          console.error("error updating user: ", error);
        });
    },
    confirmRemove() {
      console.log("confirm remove");
      this.confirmRemoveDialog = true;
    },
    deleteUser() {
      console.log("Remove user: ", this.removethisuser);
      fb_db
        .collection("users")
        .doc(this.$route.params.id)
        .delete()
        .then(() => {
          this.confirmRemoveDialog = false;
this.$router.push("/users");
        })
        .catch((err) => {
          console.error(err);
        });
    },
  },

  computed: {
    userId() {
      return this.$route.params.id;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/theme.scss";

.users {
  .user_list {
    position: absolute;
    width: 100vw;
    height: calc(100% - 150px);
    overflow-y: scroll;


      .selector {
        padding: 10px;
        display: flex;

        div {
          margin: 0px 5px;
          padding: 5px 15px;
          border-radius: 5px;
          // color: $white;
        }

        .delete {
          background: #000000;
          // color: $white;
          cursor: pointer;
          margin: 0 auto;
        }

        .item {
          padding: 10px;
          text-align: left;
        }

        .name {
        }

        .email {
        }

        .dod {
        }
                .uic {
        }
                .puic {
        }

        .approval {
        }

        .role {
        }
                .rank {
        }
      
    }
  }
  .edituser {
    form {
      overflow-y: scroll;
      height: calc(100vh - 180px);
    }
  }
}
</style>